export default __webpack_public_path__ + "static/CR_logoclaimmask2700-1a9c9eca611e97f5fdc116f8821252eb.svg";